import { render, staticRenderFns } from "./AccrualsImGroupsBuilder.vue?vue&type=template&id=3c0195f0&scoped=true"
import script from "./AccrualsImGroupsBuilder.vue?vue&type=script&lang=js"
export * from "./AccrualsImGroupsBuilder.vue?vue&type=script&lang=js"
import style0 from "./AccrualsImGroupsBuilder.vue?vue&type=style&index=0&id=3c0195f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0195f0",
  null
  
)

export default component.exports